import { CallToAction, Basic } from '@hotmart/live-triggers'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import { ENVIRONMENT, SYSTEM } from 'common/helpers/settings/.'
import useLayout from 'common/hooks/useLayout'
import { TriggerType, TypeView, Trigger } from '../../types'
import { usePostLeadContext } from 'modules/lead/context'
import { useTriggerRequest } from 'modules/trigger/hooks/useTriggerRequest'

import '@hotmart/live-triggers/dist/index.css'

interface Props {
  className?: string,
  dataTest?: string
}

const TriggerRenderer = ({ className, dataTest = 'trigger-renderer' }: Props) => {
  const { t } = useTranslation()
  const { isMobile } = useLayout()
  const { response: { contactId } } = usePostLeadContext()
  const triggerRequest = useTriggerRequest()
  const trigger = triggerRequest.data?.find(item => item.active)

  const getTriggerProps = (trigger: Trigger) => {
    const dataHubConfig = contactId ? {
      mode: ENVIRONMENT,
      scheduleCode: trigger.schedule,
      system: SYSTEM,
      triggerId: trigger.id,
      userId: contactId
    } : void 0

    return {
      title: trigger.title,
      theme: trigger.colorBackground,
      duration: trigger.duration,
      startedTime: trigger.startedAt,
      typeView: TypeView.USER,
      labelCloseButton: t('trigger.labelCloseBtn'),
      isMobile,
      datahubConfig: dataHubConfig
    }
  }

  const renderCTA = () => {
    if (!trigger) {
      return null
    }

    return (
      <CallToAction
        {...getTriggerProps(trigger)}
        textButton={trigger.buttonTitle}
        link={trigger.link}
        buttonDataTrack={trigger.duration ? 'trigger-button-cta-timer' : 'trigger-button-cta'} />
    )
  }

  const renderBasic = () => {
    if (!trigger) {
      return null
    }

    return (
      <Basic {...getTriggerProps(trigger)} />
    )
  }

  const TriggerByType = {
    [TriggerType.CTA]: renderCTA,
    [TriggerType.BASIC]: renderBasic
  }

  const renderTrigger = () => {
    if (trigger) {
      return TriggerByType[trigger.type]?.() || null
    }

    return null
  }

  return (
    <div className={classnames('trigger-renderer', className)} data-test={dataTest}>
      {renderTrigger()}
    </div>
  )
}

export default TriggerRenderer
